import {combineReducers} from 'redux';
import {IAdminTestResultsState} from 'Admin/AdminDashboard/store/adminTestResults/types';
import {communicationTestResultsReducer} from 'Admin/AdminDashboard/store/adminTestResults/reducer/communications';

export const testResultsReducer = combineReducers<IAdminTestResultsState>({
  communications: communicationTestResultsReducer
});
